import { BaseView } from '@wp-g2/styles';
var View = BaseView;
View.displayName = 'View';
export default View;